import React from 'react';
import {
    Box,
    Typography,
    Avatar,
    Chip,
    Grid
} from '@mui/material';
import { styled } from '@mui/material/styles';

const Card = styled(Box)({
    backgroundColor: '#202020',
    borderRadius: '12px',
    padding: '1.5rem',
});

const Label = styled(Typography)({
    color: '#9e9e9e',
    fontSize: '0.8rem',
    textTransform: 'uppercase',
});

const Value = styled(Typography)({
    color: '#fff',
    fontSize: '0.95rem',
});

const CourierProfile = ({ courier }) => {
    return (
        <Card>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Avatar
                    src={courier.avatarImageUrl}
                    sx={{ width: 56, height: 56, mr: 2 }}
                >
                    {(courier.name || ' ')[0]}
                </Avatar>

                <Box>
                    <Typography variant="h6">{courier.name}</Typography>
                    <Typography variant="body2" color="#12c099">
                        {courier.city}, {courier.state}
                    </Typography>
                </Box>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <Label>Email</Label>
                    <Value>{courier.email || 'N/A'}</Value>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Label>Phone</Label>
                    <Value>{courier.phone || 'N/A'}</Value>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Label>Vehicle</Label>
                    <Value>{courier.vehicleType || 'N/A'}</Value>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Label>Cargo Space</Label>
                    <Value>{courier.hasCargoSpace ? 'Yes' : 'No'}</Value>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Label>Heavy Lifting</Label>
                    <Value>{courier.canLiftHeavy ? 'Yes' : 'No'}</Value>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Label>Status</Label>
                    <Chip
                        label="Active"
                        size="small"
                        sx={{ backgroundColor: '#12c099', color: '#000' }}
                    />
                </Grid>
            </Grid>
        </Card>
    );
};

export default CourierProfile;
